import {createStore} from 'vuex';
import prochip from './modules/prochip/index.js';
import {headerfooter} from 'vue3-header-footer';
import { livechat } from "vue3-live-chat";

const store = createStore({
  modules:{
    prochip,
    headerfooter,
    livechat
  }
});

export default store;